import { Action, Module } from "vuex-class-modules";
import store from "@/store";
import { ClientsService } from "@/services/ClientsService";
import { BaseParentDocumentStore } from "@/store/modules/BaseParentDocumentStore";
import { globalStore } from "./GlobalStore";
import { ClientData } from "@/models/ClientData";
import { ClientStatistics } from "@/models/ClientStatistics";
import { DocumentType } from "@/enums/DocumentType";
import _ from "lodash";
import { OpportunityStatus } from "@/enums/OpportunityStatus";

@Module({ generateMutationSetters: true })
class ClientsStore extends BaseParentDocumentStore<ClientData, ClientsService> {
  current: ClientData = new ClientData();
  stats: ClientStatistics[] = [];

  newEntity(): ClientData {
    return new ClientData();
  }

  get service(): ClientsService {
    return new ClientsService();
  }

  @Action
  async refreshStats(): Promise<void> {
    try {
      globalStore.setIsBusy(true);
      this.stats = await this.service.getStats();
    } finally {
      globalStore.setIsBusy(false);
    }
  }

  @Action
  async select(id: string): Promise<void> {
    try {
      globalStore.setIsBusy(true);
      await super.select(id);
    } finally {
      globalStore.setIsBusy(false);
    }
  }

  @Action
  async getDocuments(): Promise<void> {
    try {
      globalStore.setIsBusy(true);
      this.entities = await this.service.getDocuments();
    } finally {
      globalStore.setIsBusy(false);
    }
  }

  get statsNumberOfClients(): number {
    return this.stats.filter((d) => d.type === DocumentType.Client).length;
  }

  get statsNumberOfBusiness(): number {
    return _.sumBy(
      this.stats.filter(
        (d) =>
          d.type === DocumentType.Opportunity &&
          d.status !== OpportunityStatus.INFORCE,
      ),
      (d) => d.count,
    );
  }

  get statsNumberOfInforceCases(): number {
    return _.sumBy(
      this.stats.filter(
        (d) =>
          d.type === DocumentType.Opportunity &&
          d.status === OpportunityStatus.INFORCE,
      ),
      (d) => d.count,
    );
  }
}

export const clientsStore = new ClientsStore({ store, name: "clients" });
